/*!
 * CookieConsent v2.9.0
 * https://www.github.com/orestbida/cookieconsent
 * Author Orest Bida
 * Released under the MIT License
 */
!function(){'use strict';var n='initCookieConsent';'undefined'!=typeof window&&'function'!=typeof window[n]&&(window[n]=function(n){var t,e,o,i,r,a,c,f,u,d,v,l,s,p,b,m,y,g,h,_,w,k,x,S,J,O,j,N,T,D,C,U,z,E,I,L={mode:'opt-in',current_lang:'en',auto_language:null,autorun:!0,page_scripts:!0,hide_from_bots:!0,cookie_name:'cc_cookie',cookie_expiration:182,cookie_domain:location.hostname,cookie_path:'/',cookie_same_site:'Lax',use_rfc_cookie:!1,autoclear_cookies:!0,revision:0,script_selector:'data-cookiecategory'},M={},R={},A=null,G=!0,H=!1,P=!1,q=!1,B=!1,F=!0,K=[],Q=!1,V=[],W=[],X=[],Y=!1,Z=[],$=[],nn=[],tn=[],en=[],on=document.documentElement,rn=function(n){'number'==typeof(t=n).cookie_expiration&&(L.cookie_expiration=t.cookie_expiration),'number'==typeof t.cookie_necessary_only_expiration&&(L.cookie_necessary_only_expiration=t.cookie_necessary_only_expiration),'boolean'==typeof t.autorun&&(L.autorun=t.autorun),'string'==typeof t.cookie_domain&&(L.cookie_domain=t.cookie_domain),'string'==typeof t.cookie_same_site&&(L.cookie_same_site=t.cookie_same_site),'string'==typeof t.cookie_path&&(L.cookie_path=t.cookie_path),'string'==typeof t.cookie_name&&(L.cookie_name=t.cookie_name),'function'==typeof t.onAccept&&(v=t.onAccept),'function'==typeof t.onFirstAction&&(s=t.onFirstAction),'function'==typeof t.onChange&&(l=t.onChange),'opt-out'===t.mode&&(L.mode='opt-out'),'number'==typeof t.revision&&(t.revision>-1&&(L.revision=t.revision),B=!0),'boolean'==typeof t.autoclear_cookies&&(L.autoclear_cookies=t.autoclear_cookies),!0===t.use_rfc_cookie&&(L.use_rfc_cookie=!0),'boolean'==typeof t.hide_from_bots&&(L.hide_from_bots=t.hide_from_bots),L.hide_from_bots&&(Y=navigator&&(navigator.userAgent&&/bot|crawl|spider|slurp|teoma/i.test(navigator.userAgent)||navigator.webdriver)),L.page_scripts=!0===t.page_scripts,'browser'===t.auto_language||!0===t.auto_language?L.auto_language='browser':'document'===t.auto_language&&(L.auto_language='document'),L.auto_language,L.current_lang=sn(t.languages,t.current_lang)},an=function(n){for(var t='accept-',e=c('c-settings'),o=c(t+'all'),i=c(t+'necessary'),r=c(t+'custom'),a=0;a<e.length;a++)e[a].setAttribute('aria-haspopup','dialog'),wn(e[a],'click',(function(n){n.preventDefault(),M.showSettings(0)}));for(a=0;a<o.length;a++)wn(o[a],'click',(function(n){f(n,'all')}));for(a=0;a<r.length;a++)wn(r[a],'click',(function(n){f(n)}));for(a=0;a<i.length;a++)wn(i[a],'click',(function(n){f(n,[])}));function c(t){return(n||document).querySelectorAll('[data-cc="'+t+'"]')}function f(n,t){n.preventDefault(),M.accept(t),M.hideSettings(),M.hide()}},cn=function(n,t){return t.hasOwnProperty(n)?n:kn(t).length>0?t.hasOwnProperty(L.current_lang)?L.current_lang:kn(t)[0]:void 0},fn=function(n){if(!0===t.force_consent&&xn(on,'force--consent'),!h){h=ln('div');var e=ln('div'),o=ln('div');h.id='cm',e.id='c-inr-i',o.id='cm-ov',h.tabIndex=-1,h.setAttribute('role','dialog'),h.setAttribute('aria-modal','true'),h.setAttribute('aria-hidden','false'),h.setAttribute('aria-labelledby','c-ttl'),h.setAttribute('aria-describedby','c-txt'),g.appendChild(h),g.appendChild(o),h.style.visibility=o.style.visibility='hidden',o.style.opacity=0}var i=t.languages[n].consent_modal.title;i&&(_||((_=ln('div')).id='c-ttl',_.setAttribute('role','heading'),_.setAttribute('aria-level','2'),e.appendChild(_)),_.innerHTML=i);var r=t.languages[n].consent_modal.description;B&&(r=F?r.replace('{{revision_message}}',''):r.replace('{{revision_message}}',t.languages[n].consent_modal.revision_message||'')),w||((w=ln('div')).id='c-txt',e.appendChild(w)),w.innerHTML=r;var a,c=t.languages[n].consent_modal.primary_btn,f=t.languages[n].consent_modal.secondary_btn;c&&(k||((k=ln('button')).id='c-p-bn',k.className='c-bn',k.appendChild(On(1)),'accept_all'===c.role&&(a='all'),wn(k,'click',(function(){M.hide(),M.accept(a)}))),k.firstElementChild.innerHTML=t.languages[n].consent_modal.primary_btn.text),f&&(x||((x=ln('button')).id='c-s-bn',x.className='c-bn c_link',x.appendChild(On(1)),'accept_necessary'===f.role?wn(x,'click',(function(){M.hide(),M.accept([])})):wn(x,'click',(function(){M.showSettings(0)}))),x.firstElementChild.innerHTML=t.languages[n].consent_modal.secondary_btn.text);var u=t.gui_options;J||((J=ln('div')).id='c-inr',J.appendChild(e)),S||((S=ln('div')).id='c-bns',u&&u.consent_modal&&!0===u.consent_modal.swap_buttons?(f&&S.appendChild(x),c&&S.appendChild(k),S.className='swap'):(c&&S.appendChild(k),f&&S.appendChild(x)),(c||f)&&J.appendChild(S),h.appendChild(J)),H=!0,an(J)},un=function(n){if(O)(C=ln('div')).id='s-bl';else{(O=ln('div')).tabIndex=-1;var e=ln('div'),o=ln('div'),i=ln('div');j=ln('div'),N=ln('div');var r=ln('div');(T=ln('button')).appendChild(On(2));var a=ln('div');D=ln('div');var c=ln('div');wn(i,'click',(function(n){q&&!j.contains(n.target)&&M.hideSettings()}),!0),O.id='s-cnt',e.id='c-vln',i.id='c-s-in',o.id='cs',N.id='s-ttl',j.id='s-inr',r.id='s-hdr',D.id='s-bl',T.id='s-c-bn',c.id='cs-ov',a.id='s-c-bnc',T.className='c-bn',O.setAttribute('role','dialog'),O.setAttribute('aria-modal','true'),O.setAttribute('aria-hidden','true'),O.setAttribute('aria-labelledby','s-ttl'),N.setAttribute('role','heading'),O.style.visibility=c.style.visibility='hidden',c.style.opacity=0,a.appendChild(T),wn(document,'keydown',(function(n){27===n.keyCode&&q&&M.hideSettings()}),!0),wn(T,'click',(function(){M.hideSettings()}))}var f=t.languages[n].settings_modal;T.setAttribute('aria-label',f.close_btn_label||'Close'),d=f.blocks,u=f.cookie_table_headers;var v=f.cookie_table_caption,l=d.length;N.innerHTML=f.title;for(var s=0;s<l;++s){var p=d[s].title,b=d[s].description,m=d[s].toggle,y=d[s].cookie_table,h=!0===t.remove_cookie_tables,_=!!b||!h&&!!y,w=ln('div'),k=ln('div');if(b){var x=ln('div');x.className='p',x.insertAdjacentHTML('beforeend',b)}var S=ln('div');if(S.className='title',w.className='c-bl',k.className='desc',void 0!==m){var J='c-ac-'+s,L=ln(_?'button':'div'),A=ln('label'),H=ln('input'),P=ln('span'),B=ln('span'),F=ln('span'),K=ln('span');L.className=_?'b-tl exp':'b-tl',A.className='b-tg',H.className='c-tgl',F.className='on-i',K.className='off-i',P.className='c-tg',B.className='t-lb',_&&(L.setAttribute('aria-expanded','false'),L.setAttribute('aria-controls',J)),H.type='checkbox',P.setAttribute('aria-hidden','true');var Q=m.value;H.value=Q,B.textContent=p,L.insertAdjacentHTML('beforeend',p),S.appendChild(L),P.appendChild(F),P.appendChild(K),G?m.enabled?(H.checked=!0,!C&&nn.push(!0),m.enabled&&!C&&X.push(Q)):!C&&nn.push(!1):vn(R.categories,Q)>-1?(H.checked=!0,!C&&nn.push(!0)):!C&&nn.push(!1),!C&&tn.push(Q),m.readonly&&(H.disabled=!0,xn(P,'c-ro'),!C&&en.push(Q)),xn(k,'b-acc'),xn(S,'b-bn'),xn(w,'b-ex'),k.id=J,k.setAttribute('aria-hidden','true'),A.appendChild(H),A.appendChild(P),A.appendChild(B),S.appendChild(A),_&&function(n,t,e){wn(L,'click',(function(){Jn(t,'act')?(Sn(t,'act'),e.setAttribute('aria-expanded','false'),n.setAttribute('aria-hidden','true')):(xn(t,'act'),e.setAttribute('aria-expanded','true'),n.setAttribute('aria-hidden','false'))}),!1)}(k,w,L)}else if(p){var V=ln('div');V.className='b-tl',V.setAttribute('role','heading'),V.setAttribute('aria-level','3'),V.insertAdjacentHTML('beforeend',p),S.appendChild(V)}if(p&&w.appendChild(S),b&&k.appendChild(x),!h&&void 0!==y){for(var W=document.createDocumentFragment(),Y=0;Y<u.length;++Y){var Z=ln('th'),$=u[Y];if(Z.setAttribute('scope','col'),$){var on=$&&kn($)[0];Z.textContent=u[Y][on],W.appendChild(Z)}}var rn=ln('tr');rn.appendChild(W);var an=ln('thead');an.appendChild(rn);var cn=ln('table');if(v){var fn=ln('caption');fn.innerHTML=v,cn.appendChild(fn)}cn.appendChild(an);for(var un=document.createDocumentFragment(),dn=0;dn<y.length;dn++){for(var sn=ln('tr'),pn=0;pn<u.length;++pn)if($=u[pn]){on=kn($)[0];var bn=ln('td');bn.insertAdjacentHTML('beforeend',y[dn][on]),bn.setAttribute('data-column',$[on]),sn.appendChild(bn)}un.appendChild(sn)}var mn=ln('tbody');mn.appendChild(un),cn.appendChild(mn),k.appendChild(cn)}(m&&p||!m&&(p||b))&&(w.appendChild(k),C?C.appendChild(w):D.appendChild(w))}U||((U=ln('div')).id='s-bns'),E||((E=ln('button')).id='s-all-bn',E.className='c-bn',U.appendChild(E),wn(E,'click',(function(){M.accept('all'),M.hideSettings(),M.hide()}))),E.innerHTML=f.accept_all_btn;var yn=f.reject_all_btn;if(yn&&(I||((I=ln('button')).id='s-rall-bn',I.className='c-bn',wn(I,'click',(function(){M.accept([]),M.hideSettings(),M.hide()})),j.className='bns-t',U.appendChild(I)),I.innerHTML=yn),z||((z=ln('button')).id='s-sv-bn',z.className='c-bn',U.appendChild(z),wn(z,'click',(function(){M.accept(),M.hideSettings(),M.hide()}))),z.innerHTML=f.save_settings_btn,C)return j.replaceChild(C,D),void(D=C);r.appendChild(N),r.appendChild(a),j.appendChild(r),j.appendChild(D),j.appendChild(U),i.appendChild(j),o.appendChild(i),e.appendChild(o),O.appendChild(e),g.appendChild(O),g.appendChild(c)};M.updateLanguage=function(n,e){if('string'==typeof n){var o=cn(n,t.languages);return(o!==L.current_lang||!0===e)&&(L.current_lang=o,H&&fn(o),un(o),!0)}};var dn=function(n){var t=d.length,e=-1;Q=!1;var o=hn('','all'),i=[L.cookie_domain,'.'+L.cookie_domain];if('www.'===L.cookie_domain.slice(0,4)){var r=L.cookie_domain.substr(4);i.push(r),i.push('.'+r)}for(var a=0;a<t;a++){var c=d[a];if(c.hasOwnProperty('toggle')){var f=vn(K,c.toggle.value)>-1;if(!nn[++e]&&c.hasOwnProperty('cookie_table')&&(n||f)){var v=c.cookie_table,l=kn(u[0])[0],s=v.length;'on_disable'===c.toggle.reload&&f&&(Q=!0);for(var p=0;p<s;p++){var b=i,m=v[p],y=[],g=m[l],h=m.is_regex||!1,_=m.domain||null,w=m.path||!1;if(_&&(b=[_,'.'+_]),h)for(var k=0;k<o.length;k++)o[k].match(g)&&y.push(o[k]);else{var x=vn(o,g);x>-1&&y.push(o[x])}y.length>0&&(_n(y,w,b),'on_clear'===c.toggle.reload&&(Q=!0))}}}}},vn=function(n,t){return n.indexOf(t)},ln=function(n){var t=document.createElement(n);return'button'===n&&t.setAttribute('type',n),t},sn=function(n,t){return'browser'===L.auto_language?cn(pn(),n):'document'===L.auto_language?cn(document.documentElement.lang,n):'string'==typeof t?L.current_lang=cn(t,n):(L.current_lang,L.current_lang)},pn=function(){var n=navigator.language||navigator.browserLanguage;return n.length>2&&(n=n[0]+n[1]),n.toLowerCase()};M.allowedCategory=function(n){if(G&&'opt-in'!==L.mode)t=X;else var t=JSON.parse(hn(L.cookie_name,'one',!0)||'{}').categories||[];return vn(t,n)>-1},M.run=function(t){if(!document.getElementById('cc_div')){if(rn(t),Y)return;R=JSON.parse(hn(L.cookie_name,'one',!0)||'{}');var c=void 0!==(i=R.consent_uuid);if((e=R.consent_date)&&(e=new Date(e)),(o=R.last_consent_update)&&(o=new Date(o)),A=void 0!==R.data?R.data:null,B&&R.revision!==L.revision&&(F=!1),H=G=!(c&&F&&e&&o&&i),function(){(y=ln('div')).id='cc--main',y.style.position='fixed',y.innerHTML='<div id="cc_div" class="cc_div"></div>',g=y.children[0];var t=L.current_lang;H&&fn(t),un(t),(n||document.body).appendChild(y)}(),function(){var n=['[href]','button','input','details','[tabindex="0"]'];function t(t,e){var o=!1,i=!1;try{for(var r,a=t.querySelectorAll(n.join(':not([tabindex="-1"]), ')),c=a.length,f=0;f<c;)r=a[f].getAttribute('data-focus'),i||'1'!==r?'0'===r&&(o=a[f],i||'0'===a[f+1].getAttribute('data-focus')||(i=a[f+1])):i=a[f],f++}catch(e){return t.querySelectorAll(n.join(', '))}e[0]=a[0],e[1]=a[a.length-1],e[2]=o,e[3]=i}t(j,$),H&&t(h,Z)}(),function(n,t){if('object'==typeof n){var e=n.consent_modal,o=n.settings_modal;H&&e&&i(h,['box','bar','cloud'],['top','middle','bottom'],['zoom','slide'],e.layout,e.position,e.transition),o&&i(O,['bar'],['left','right'],['zoom','slide'],o.layout,o.position,o.transition)}function i(n,t,e,o,i,r,a){if(r=r&&r.split(' ')||[],vn(t,i)>-1&&(xn(n,i),('bar'!==i||'middle'!==r[0])&&vn(e,r[0])>-1))for(var c=0;c<r.length;c++)xn(n,r[c]);vn(o,a)>-1&&xn(n,a)}}(t.gui_options),an(),L.autorun&&H&&M.show(t.delay||0),setTimeout((function(){xn(y,'c--anim')}),30),setTimeout((function(){wn(document,'keydown',(function(n){if('Tab'===n.key&&(P||q)&&r){var t=Tn();n.shiftKey?t!==r[0]&&a.contains(t)||(n.preventDefault(),jn(r[1])):t!==r[1]&&a.contains(t)||(n.preventDefault(),jn(r[0]))}}))}),100),G)'opt-out'===L.mode&&(L.mode,bn(X));else{var f='boolean'==typeof R.rfc_cookie;(!f||f&&R.rfc_cookie!==L.use_rfc_cookie)&&(R.rfc_cookie=L.use_rfc_cookie,gn(L.cookie_name,JSON.stringify(R))),p=yn(mn()),bn(),'function'==typeof v&&v(R)}}};var bn=function(n){if(L.page_scripts){var t=document.querySelectorAll('script['+L.script_selector+']'),e=n||R.categories||[],o=function(n,t){if(t<n.length){var i=n[t],r=i.getAttribute(L.script_selector);if(vn(e,r)>-1){i.type=i.getAttribute('data-type')||'text/javascript',i.removeAttribute(L.script_selector);var a=i.getAttribute('data-src');a&&i.removeAttribute('data-src');var c=ln('script');if(c.textContent=i.innerHTML,function(n,t){for(var e=t.attributes,o=e.length,i=0;i<o;i++){var r=e[i].nodeName;n.setAttribute(r,t[r]||t.getAttribute(r))}}(c,i),a?c.src=a:a=i.src,a&&(c.readyState?c.onreadystatechange=function(){'loaded'!==c.readyState&&'complete'!==c.readyState||(c.onreadystatechange=null,o(n,++t))}:c.onload=function(){c.onload=null,o(n,++t)}),i.parentNode.replaceChild(c,i),a)return}o(n,++t)}};o(t,0)}};M.set=function(n,t){return'data'===n&&function(n,t){var e=!1;if('update'===t){var o=typeof(A=M.get('data'))==typeof n;if(o&&'object'==typeof A)for(var i in!A&&(A={}),n)A[i]!==n[i]&&(A[i]=n[i],e=!0);else!o&&A||A===n||(A=n,e=!0)}else A=n,e=!0;return e&&(R.data=A,gn(L.cookie_name,JSON.stringify(R))),e}(t.value,t.mode)},M.get=function(n,t){return JSON.parse(hn(t||L.cookie_name,'one',!0)||'{}')[n]},M.getConfig=function(n){return L[n]||t[n]};var mn=function(){return V=R.categories||[],W=tn.filter((function(n){return-1===vn(V,n)})),{accepted:V,rejected:W}},yn=function(n){var t='custom',e=en.length;return n.accepted.length===tn.length?t='all':n.accepted.length===e&&(t='necessary'),t};M.getUserPreferences=function(){var n=mn();return{accept_type:yn(n),accepted_categories:n.accepted,rejected_categories:n.rejected}},M.loadScript=function(n,t,e){var o='function'==typeof t;if(document.querySelector('script[src="'+n+'"]'))o&&t();else{var i=ln('script');if(e&&e.length>0)for(var r=0;r<e.length;++r)e[r]&&i.setAttribute(e[r].name,e[r].value);o&&(i.onload=t),i.src=n,document.head.appendChild(i)}},M.updateScripts=function(){bn()},M.show=function(n,t){!0===t&&fn(L.current_lang),H&&(b=Tn(),r=Z,a=h,P=!0,h.removeAttribute('aria-hidden'),setTimeout((function(){xn(on,'show--consent')}),n>0?n:t?30:0))},M.hide=function(){H&&(P=!1,jn(c),h.setAttribute('aria-hidden','true'),Sn(on,'show--consent'),jn(b),b=null)},M.showSettings=function(n){q=!0,O.removeAttribute('aria-hidden'),P?m=Tn():b=Tn(),a=O,r=$,setTimeout((function(){xn(on,'show--settings')}),n>0?n:0)},M.hideSettings=function(){q=!1,Nn(),jn(f),O.setAttribute('aria-hidden','true'),Sn(on,'show--settings'),P?(jn(m),m=null,a=h,r=Z):(jn(b),b=null)},M.accept=function(n,t){var r=n||void 0,a=t||[],c=[];if(r)if('object'==typeof r&&'number'==typeof r.length)for(var f=0;f<r.length;f++)-1!==vn(tn,r[f])&&c.push(r[f]);else'string'==typeof r&&('all'===r?c=tn.slice():-1!==vn(tn,r)&&c.push(r));else c=function(){for(var n=document.querySelectorAll('.c-tgl')||[],t=[],e=0;e<n.length;e++)n[e].checked&&t.push(n[e].value);return t}();if(a.length>=1)for(f=0;f<a.length;f++)c=c.filter((function(n){return n!==a[f]}));for(f=0;f<tn.length;f++)!0===en.includes(tn[f])&&-1===vn(c,tn[f])&&c.push(tn[f]);!function(n){K=[];var t=O.querySelectorAll('.c-tgl')||[];if(t.length>0)for(var r=0;r<t.length;r++)-1!==vn(n,tn[r])?(t[r].checked=!0,nn[r]||(K.push(tn[r]),nn[r]=!0)):(t[r].checked=!1,nn[r]&&(K.push(tn[r]),nn[r]=!1));!G&&L.autoclear_cookies&&K.length>0&&dn(),e||(e=new Date),i||(i=([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,(function(n){try{return(n^(window.crypto||window.msCrypto).getRandomValues(new Uint8Array(1))[0]&15>>n/4).toString(16)}catch(n){return''}}))),R={categories:n,level:n,revision:L.revision,data:A,rfc_cookie:L.use_rfc_cookie,consent_date:e.toISOString(),consent_uuid:i},(G||K.length>0)&&(F=!0,o=o?new Date:e,R.last_consent_update=o.toISOString(),p=yn(mn()),gn(L.cookie_name,JSON.stringify(R)),bn()),G&&(L.autoclear_cookies&&dn(!0),'function'==typeof s&&s(M.getUserPreferences(),R),'function'==typeof v&&v(R),G=!1,'opt-in'===L.mode)||('function'==typeof l&&K.length>0&&l(R,K),Q&&location.reload())}(c)},M.eraseCookies=function(n,t,e){var o=[],i=e?[e,'.'+e]:[L.cookie_domain,'.'+L.cookie_domain];if('object'==typeof n&&n.length>0)for(var r=0;r<n.length;r++)this.validCookie(n[r])&&o.push(n[r]);else this.validCookie(n)&&o.push(n);_n(o,t,i)};var gn=function(n,t){var e=L.cookie_expiration;'number'==typeof L.cookie_necessary_only_expiration&&'necessary'===p&&(e=L.cookie_necessary_only_expiration),t=L.use_rfc_cookie?encodeURIComponent(t):t;var o=new Date;o.setTime(o.getTime()+24*e*60*60*1e3);var i=n+'='+(t||'')+'; expires='+o.toUTCString()+'; Path='+L.cookie_path+';';i+=' SameSite='+L.cookie_same_site+';',location.hostname.indexOf('.')>-1&&L.cookie_domain&&(i+=' Domain='+L.cookie_domain+';'),'https:'===location.protocol&&(i+=' Secure;'),document.cookie=i},hn=function(n,t,e){var o;if('one'===t){if((o=(o=document.cookie.match('(^|;)\\s*'+n+'\\s*=\\s*([^;]+)'))?e?o.pop():n:'')&&n===L.cookie_name){try{o=JSON.parse(o)}catch(n){try{o=JSON.parse(decodeURIComponent(o))}catch(n){o={}}}o=JSON.stringify(o)}}else if('all'===t){var i=document.cookie.split(/;\s*/);o=[];for(var r=0;r<i.length;r++)o.push(i[r].split('=')[0])}return o},_n=function(n,t,e){for(var o=t||'/',i=0;i<n.length;i++){for(var r=0;r<e.length;r++)document.cookie=n[i]+'=; path='+o+(0==e[r].indexOf('.')?'; domain='+e[r]:'')+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';n[i]}};M.validCookie=function(n){return''!==hn(n,'one',!0)};var wn=function(n,t,e,o){n.addEventListener(t,e,!0===o&&{passive:!0})},kn=function(n){if('object'==typeof n)return Object.keys(n)},xn=function(n,t){n.classList.add(t)},Sn=function(n,t){n.classList.remove(t)},Jn=function(n,t){return n.classList.contains(t)},On=function(n){var t=ln('span');return t.tabIndex=-1,1===n?c=t:f=t,t},jn=function(n){n&&n instanceof HTMLElement&&n.focus()},Nn=function(){for(var n=j.querySelectorAll('.c-tgl'),t=0;t<n.length;t++){var e=n[t].value,o=en.includes(e);n[t].checked=o||M.allowedCategory(e)}},Tn=function(){return document.activeElement};return M})}();
/**
 * $.disablescroll
 * Author: Josh Harrison - aloof.co
 *
 * Disables scroll events from mousewheels, touchmoves and keypresses.
 * Use while jQuery is animating the scroll position for a guaranteed super-smooth ride!
 */

/*
USAGE
var $window = $(window);
$window.disablescroll();
$window.disablescroll('undo');

$window.disablescroll({
    handleScrollbar: false
});
*/

;(function($) {

    "use strict";

    var instance, proto;

    function UserScrollDisabler($container, options) {
        // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
        // left: 37, up: 38, right: 39, down: 40
        this.opts = $.extend({
            handleWheel : true,
            handleScrollbar: true,
            handleKeys : true,
            scrollEventKeys : [32, 33, 34, 35, 36, 37, 38, 39, 40] // 32, - spacebar
        }, options);

        this.$container = $container;
        this.$document = $(document);
        this.lockToScrollPos = [0, 0];

        this.disable();
    }

    proto = UserScrollDisabler.prototype;

    proto.disable = function() {
        var t = this;

        if(t.opts.handleWheel) {
            t.$container.on(
                "mousewheel.disablescroll DOMMouseScroll.disablescroll touchmove.disablescroll",
                t._handleWheel
            );
        }

        if(t.opts.handleScrollbar) {
            t.lockToScrollPos = [
                t.$container.scrollLeft(),
                t.$container.scrollTop()
            ];
            t.$container.on("scroll.disablescroll", function() {
                t._handleScrollbar.call(t);
            });
        }

        if(t.opts.handleKeys) {
            t.$document.on("keydown.disablescroll", function(event) {
                t._handleKeydown.call(t, event);
            });
        }
    };

    proto.undo = function() {
        var t = this;
        t.$container.off(".disablescroll");
        if(t.opts.handleKeys) {
            t.$document.off(".disablescroll");
        }
    };

    proto._handleWheel = function(event) {
        event.preventDefault();
    };

    proto._handleScrollbar = function() {
        this.$container.scrollLeft(this.lockToScrollPos[0]);
        this.$container.scrollTop(this.lockToScrollPos[1]);
    };

    proto._handleKeydown = function(event) {
        for (var i = 0; i < this.opts.scrollEventKeys.length; i++) {
            if (event.keyCode === this.opts.scrollEventKeys[i]) {
                event.preventDefault();
                return;
            }
        }
    };


    // Plugin wrapper for object
    $.fn.disablescroll = function(method) {

        // If calling for the first time, instantiate the object and save
        // reference. The plugin can therefore only be instantiated once per
        // page. You can pass options object in through the method parameter.
        if( ! instance && (typeof method === "object" || ! method)) {
            instance = new UserScrollDisabler(this, method);
        }

        // Instance created, no method specified. Call disable again
        if(instance && typeof method === "undefined") {
            instance.disable();
        }

        // Instance already created, and a method is being explicitly called,
        // e.g. .disablescroll('undo');
        else if(instance && instance[method]) {
            instance[method].call(instance);
        }

        return this;

    };

    // Global access
    window.UserScrollDisabler = UserScrollDisabler;

})(jQuery);
/*!
 * imagesLoaded PACKAGED v4.1.3
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

/*
$('#container').imagesLoaded( function() {
  // images have loaded
});

// options
$('#container').imagesLoaded( {
  // options...
  },
  function() {
    // images have loaded
  }
);

OR

$('#container').imagesLoaded()
  .always( function( instance ) {
    console.log('all images loaded');
  })
  .done( function( instance ) {
    console.log('all images successfully loaded');
  })
  .fail( function() {
    console.log('all images loaded, at least one is broken');
  })
  .progress( function( instance, image ) {
    var result = image.isLoaded ? 'loaded' : 'broken';
    console.log( 'image is ' + result + ' for ' + image.img.src );
  });
*/

!function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var i=this._events=this._events||{},n=i[e]=i[e]||[];return n.indexOf(t)==-1&&n.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var i=this._onceEvents=this._onceEvents||{},n=i[e]=i[e]||{};return n[t]=!0,this}},t.off=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=i.indexOf(t);return n!=-1&&i.splice(n,1),this}},t.emitEvent=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){i=i.slice(0),t=t||[];for(var n=this._onceEvents&&this._onceEvents[e],o=0;o<i.length;o++){var r=i[o],s=n&&n[r];s&&(this.off(e,r),delete n[r]),r.apply(this,t)}return this}},t.allOff=function(){delete this._events,delete this._onceEvents},e}),function(e,t){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return t(e,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function i(e,t){for(var i in t)e[i]=t[i];return e}function n(e){if(Array.isArray(e))return e;var t="object"==typeof e&&"number"==typeof e.length;return t?d.call(e):[e]}function o(e,t,r){if(!(this instanceof o))return new o(e,t,r);var s=e;return"string"==typeof e&&(s=document.querySelectorAll(e)),s?(this.elements=n(s),this.options=i({},this.options),"function"==typeof t?r=t:i(this.options,t),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(this.check.bind(this))):void a.error("Bad element for imagesLoaded "+(s||e))}function r(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var h=e.jQuery,a=e.console,d=Array.prototype.slice;o.prototype=Object.create(t.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&u[t]){for(var i=e.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=e.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var u={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(t.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,e),n=i.exec(t.backgroundImage)}},o.prototype.addImage=function(e){var t=new r(e);this.images.push(t)},o.prototype.addBackground=function(e,t){var i=new s(e,t);this.images.push(i)},o.prototype.check=function(){function e(e,i,n){setTimeout(function(){t.progress(e,i,n)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},o.prototype.progress=function(e,t,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,e,t)},o.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},r.prototype=Object.create(t.prototype),r.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},r.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},r.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},o.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(h=t,h.fn.imagesLoaded=function(e,t){var i=new o(this,e,t);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
		target.style.overflow = 'hidden';
		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === target) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				xRatio = (img.width - targetWidth) / sourceWidth;
				yRatio = (img.height - targetHeight) / sourceHeight;

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);

				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, defaults, options || {}),
			//target will display the zoomed image
			target = settings.target && $(settings.target)[0] || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				var srcElement = source.querySelector('img');
				if (srcElement) {
					settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
				}
				if (!settings.url) {
					return;
				}
			}

			$source.one('zoom.destroy', function(position, overflow){
				$source.off(".zoom");
				target.style.position = position;
				target.style.overflow = overflow;
				img.onload = null;
				$img.remove();
			}.bind(this, target.style.position, target.style.overflow));

			img.onload = function () {
				var zoom = $.zoom(target, source, img, settings.magnify);

				function start(e) {
					zoom.init();
					zoom.move(e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$source
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					$source
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							} else {
								touched = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
						})
						.on('touchmove.zoom', function (e) {
							e.preventDefault();
							zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
						})
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							}
						});
				}
				
				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.setAttribute('role', 'presentation');
			img.alt = '';
			img.src = settings.url;
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));

/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}

					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}

				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			var jar = {};
			var decode = function (s) {
				return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
			};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, arguments);
		};
		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));
const devMode = nk_ajax_vars.devMode == '1' ? true : false;

var windowWidth, windowHeight, documentWidth, documentHeight, topScrollPosition;
var siteRoot = window.location.protocol + '//' + window.location.host;

/*-------------------------------------------------------------------------*/
//
// INFO: Animations
//
/*-------------------------------------------------------------------------*/

// jQuery(document).ready(function($) {

// add image-paralax
// this takes

const paralaxY = windowWidth > 800 ? 100 : 40;

const splitLetters = async function () {
    let splitLettersDiv = document.querySelectorAll('.animate-letters');
    if (!splitLettersDiv.length) return;

    const results = Splitting({ target: splitLettersDiv, by: 'chars' });
};
splitLetters();

// Image Drop
const imageDrop = function () {
    const imagesToAnimate = gsap.utils.toArray('.image-drop');
    if (!imagesToAnimate.length) return;
    // console.log('Animate: Drop Image', imagesToAnimate);
    imagesToAnimate.forEach((imageWrapper) => {
        let animateImages = gsap.timeline({
            scrollTrigger: {
                trigger: imageWrapper,
                // markers: devMode,
                start: 'top bottom-=30%',
                id: 'imageDrop',
            },
        });
        animateImages.from(imageWrapper, {
            autoAlpha: 0,
            duration: 0.6,
            clipPath: 'inset(0% 0% 100%)',
            ease: Power2.easeInOut,
        });
    });
};

const ctaParalax = function () {
    const imagesToAnimate = gsap.utils.toArray('.image-paralax .cta-box');
    if (!imagesToAnimate.length) return;
    // console.log('Pralax on images', imagesToAnimate);

    imagesToAnimate.forEach((imageWrapper) => {
        const p = gsap.utils.selector(imageWrapper);
        imageWrapper.img = imageWrapper.querySelector('img');

        gsap.fromTo(
            imageWrapper.img,
            {
                y: -paralaxY,
            },
            {
                y: +paralaxY,
                ease: 'none',
                scrollTrigger: {
                    trigger: imageWrapper,
                    scrub: true,
                },
            }
        );
    });
};

const ctaParalaxVertical = function () {
    const imagesToAnimate = gsap.utils.toArray('.image-paralax-vertical .cta-box');
    if (!imagesToAnimate.length) return;
    // console.log('Vertical paralax on images', imagesToAnimate);

    imagesToAnimate.forEach((imageWrapper) => {
        const p = gsap.utils.selector(imageWrapper);
        imageWrapper.img = imageWrapper.querySelector('img');

        gsap.fromTo(
            imageWrapper.img,
            {
                x: -50,
            },
            {
                x: +50,
                ease: 'none',
                scrollTrigger: {
                    trigger: imageWrapper,
                    scrub: 0.3,
                },
            }
        );
    });
};

const slidesIn = function () {
    const imagesToAnimate = gsap.utils.toArray('.slides-in .slick-slider .slick-track');
    if (!imagesToAnimate.length) return;
    // console.log('Animate slider', imagesToAnimate);

    imagesToAnimate.forEach((imageWrapper) => {
        let slides = gsap.utils.toArray(imageWrapper.querySelectorAll('div > li'));

        gsap.fromTo(
            slides,
            {
                x: 100,
                opacity: 0,
                scale: 0.9,
            },
            {
                x: 0,
                opacity: 1,
                scale: 1,
                ease: 'none',
                scrollTrigger: {
                    trigger: imageWrapper,
                    // markers: devMode,
                    start: 'top bottom-=20%',
                },
                ease: Power2.easeInOut,
                stagger: 0.1,
            }
        );
    });
};

const animateLetters = async () => {
    const splitLettersWrap = gsap.utils.toArray('.animate-letters');
    if (!splitLettersWrap.length) return;

    await splitLetters();

    // console.log('Animate letters', splitLettersWrap);
    splitLettersWrap.forEach((animatedSentence) => {
        let letters = gsap.utils.toArray(animatedSentence.querySelectorAll('.char'));

        gsap.fromTo(
            letters,
            {
                xPercent: 20,
                opacity: 0,
            },
            {
                scrollTrigger: {
                    trigger: animatedSentence,
                    // markers: devMode,
                    id: 'letters',
                    start: 'top bottom-=30%',
                    onEnter: () => {
                        animatedSentence.parentElement.classList.add('visible');
                    },
                },
                ease: Power2.easeOut,
                xPercent: 0,
                stagger: 0.06,
                duration: (i) => i * 0.3,
                opacity: 1,
            }
        );
    });
};

window.onload = function initAnimations() {
    // console.log('Window loaded animations');
    imageDrop();
    ctaParalax();
    ctaParalaxVertical();
    slidesIn();
    animateLetters();
};

jQuery(document).ready(function ($) {
    function sliderNotices() {
        const topNotices = $('.top-notices');
        if (!topNotices.length) return;

        // topNotices.hide();

        topNotices.on('init', function (event, slick, currentSlide, nextSlide) {
            // topNotices.slideDown();
        });

        topNotices.slick({
            dots: false,
            arrows: false,
            infinite: true,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: true,
            autoplaySpeed: 4000,
        });
    }

    function sliderHeaderInit() {
        const sliderHeader = $('.header-slider .slides');
        if (!sliderHeader.length) return;

        sliderHeader.on('init afterChange', function (event, slick, currentSlide, nextSlide) {
            const current = (currentSlide ? currentSlide : 0) + 1;
            const allSlides = slick.slideCount;
            sliderHeader.closest('.slider-with-nav').find('.slide-number .current').text(current);
            sliderHeader.closest('.slider-with-nav').find('.slide-number .all').text(allSlides);
            sliderHeader.find('.cta-middle').addClass('animate-slide');
        });

        sliderHeader.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            sliderHeader.find('.cta-middle').removeClass('animate-slide');
        });
        sliderHeader.on('init', function (event, slick, currentSlide, nextSlide) {
            sliderHeader.closest('.slider-with-nav').find('.slider-nav').css('opacity', '1');
        });

        sliderHeader.slick({
            dots: false,
            arrows: false,
            infinite: true,
            fade: false,
            cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
            speed: 300,
            autoplay: true,
            autoplaySpeed: 5000,
        });
    }

    function flexibleProductsSlider() {
        const flexProdSlider = $('.product-slider .slides');
        if (!flexProdSlider.length) return;

        flexProdSlider.slick({
            dots: false,
            arrows: false,
            infinite: true,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
    flexibleProductsSlider();

    function historySliderInit() {
        const historySlider = $('.history-slider .slides');
        const historySliderNav = $('.slides-year-nav');
        if (!historySlider.length) return;

        historySliderNav.on('afterChange', function (event, slick, currentSlide) {
            // console.log(slick, currentSlide);
            if (currentSlide >= slick.$slides.length - 7) {
                historySliderNav.removeClass('faded');
            } else {
                historySliderNav.addClass('faded');
            }
        });

        historySlider.slick({
            dots: false,
            arrows: false,
            infinite: false,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.slides-year-nav',
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
        historySliderNav.slick({
            dots: false,
            arrows: false,
            infinite: false,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 7,
            slidesToScroll: 1,
            asNavFor: '.history-slider .slides',
            centerMode: false,
            focusOnSelect: true,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    function productRangeSlider() {
        const rangeProdSlider = $('.range-slider .slides');
        if (!rangeProdSlider.length) return;

        rangeProdSlider.slick({
            dots: false,
            arrows: false,
            infinite: false,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 2.33,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    function productUpSellsSlider() {
        if (windowWidth > 500) return;
        const upSellsSlider = $('.single-product .upsells-slider .slides');
        if (!upSellsSlider.length) return;

        upSellsSlider.slick({
            dots: false,
            arrows: false,
            infinite: false,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }

    // slider navigation
    $('.slider-nav').on('click', '.prev', function (e) {
        const slider = $(this).closest('.slider-with-nav').find('.slides').slick('slickPrev');
    });
    $('.slider-nav').on('click', '.next', function (e) {
        const slider = $(this).closest('.slider-with-nav').find('.slides').slick('slickNext');
    });

    function sliderHandler() {
        const gallerySlider = $('.gallery-images');
        if (!gallerySlider.length) return;

        gallerySlider.on('init afterChange', function (event, slick, currentSlide, nextSlide) {
            const current = (currentSlide ? currentSlide : 0) + 1;
            const allSlides = slick.slideCount;
            gallerySlider.closest('.slider-with-nav').find('.slide-number .current').text(current);
            gallerySlider.closest('.slider-with-nav').find('.slide-number .all').text(allSlides);
        });
        const varticalSlider = windowWidth > 1000 ? true : false;

        gallerySlider.slick({
            dots: false,
            arrows: true,
            infinite: false,
            fade: false,
            cssEase: 'linear',
            speed: 300,
            autoplay: false,
            autoplaySpeed: 4000,
            vertical: varticalSlider,
            // responsive: [
            //     {
            //         breakpoint: 1000,
            //         settings: {
            //             vertical: false,
            //         },
            //     },
            // ],
        });
    }
    function sliderLifestyleHandler() {
        const lifestyleSlider = $('.slider-lifestyle');
        if (!lifestyleSlider.length) return;

        lifestyleSlider.on('init', function (event, slick, currentSlide, nextSlide) {});

        lifestyleSlider.slick({
            dots: false,
            arrows: true,
            infinite: false,
            fade: false,
            cssEase: 'linear',
            speed: 300,
        });
    }

    // Init all sliders
    $(window).imagesLoaded(function () {
        // console.log('ScrollTrigger', ScrollTrigger);
        // some code
        sliderHandler();
        sliderLifestyleHandler();
        sliderNotices();
        sliderHeaderInit();
        historySliderInit();
        productRangeSlider();
        productUpSellsSlider();
        ScrollTrigger.refresh();
    });
});

/*
Markup:
<dl class="accordion">

<dt><a href="">Panel 1</a></dt>
<dd>Pellentesque fermentum dolor. Aliquam quam lectus, facilisis auctor, ultrices ut, elementum vulputate, nunc.</dd>

<dt><a href="">Panel 2</a></dt>
<dd>Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim pellentesque felis.</dd>

<dt><a href="">Panel 3</a></dt>
<dd>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</dd>

</dl>
*/
// $('.accordion').nkAccordion();
// $('.to-open a').trigger('click');

;(function($) {

    $.fn.nkAccordion = function() {
        var acc = $(this),
            allPanels = acc.find('dd').not('.open').hide();

        acc.find('dt > a').on('click', function(e) {
            $(this).closest('dt').toggleClass('open');
            $(this).parent().next().toggleClass('open').slideToggle();
            return false;
        })

    };

}) (jQuery);


/*-------------------------------------------------------------------------*/
//
/* !	Cookies
//
/*-------------------------------------------------------------------------*/
window.addEventListener('load', function () {
    const cc = initCookieConsent();
    var LOREM_IPSUM =
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
    cc.run({
        autorun: true,
        current_lang: 'en',
        page_scripts: true,

        autoclear_cookies: true, // default: false
        cookie_name: 'croots_cookie_consent', // default: 'cc_cookie'
        cookie_expiration: 90, // default: 182
        force_consent: true,
        gui_options: {
            consent_modal: {
                layout: 'bar', // box/cloud/bar
                position: 'bottom', // bottom/middle/top + left/right/center
                transition: 'slide', // zoom/slide
                swap_buttons: false, // enable to invert buttons
            },
            settings_modal: {
                layout: 'box', // box/bar
                position: 'left', // left/right
                transition: 'slide', // zoom/slide
            },
        },
        onFirstAction: function () {
            // console.log('onFirstAction fired');
        },

        onAccept: function (cookie) {
            // console.log('onAccept fired!');
        },

        onChange: function (cookie, changed_preferences) {},
        languages: {
            en: {
                consent_modal: {
                    title: '',
                    description:
                        "We use cookies to personalise content, ads and to analyse our traffic. We also share information about your use of our site with our advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services. Please see our <a href='https://crootsengland.co.uk/privacy-policy/'>cookies and privacy policy</a> for more details",
                    primary_btn: {
                        text: 'Accept all',
                        role: 'accept_all', //'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Preferences',
                        role: 'settings', //'settings' or 'accept_necessary'
                    },
                    revision_message:
                        '<br><br> Dear user, terms and conditions have changed since the last time you visisted!',
                },
                settings_modal: {
                    title: 'Cookie settings',
                    save_settings_btn: 'Save current selection',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [{ col1: 'Name' }, { col2: 'Domain' }, { col3: 'Expiration' }],
                    blocks: [
                        {
                            title: 'Cookie usage',
                            description:
                                'We use cookies to help us improve your experience on our website. By clicking \'accept all\', you consent to our use of cookies. You can manage your cookies settings below. For more information, please see our <a href="https://crootsengland.co.uk/privacy-policy/" class="cc-link">Privacy Policy</a>.',
                        },
                        {
                            title: 'Strictly necessary cookies',
                            description:
                                'These are cookies that are required for the operation of our website. They include, for example, cookies that enable you to log in to secure areas of our website, use a shopping cart or make use of e-billing services.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true, //cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                        },
                        {
                            title: 'Analytics & Performance cookies',
                            description:
                                'They allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily.',
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false,
                            },
                            cookie_table: [
                                {
                                    col1: '^_ga',
                                    col2: 'crootsengland.co.uk',
                                    col3: 'after 7 days',
                                    is_regex: true,
                                },
                            ],
                        },
                    ],
                },
            },
        },
    });
});

// console.log('nk_ajax_vars', nk_ajax_vars);

jQuery(document).ready(function ($) {
    const body = $('body');
    const $window = $(window);

    function recalculateSizes() {
        windowWidth = $(window).width(); //retrieve current window width
        windowHeight = $(window).height(); //retrieve current window height
        documentWidth = $(document).width(); //retrieve current document width
        documentHeight = $(document).height(); //retrieve current document height
        topScrollPosition = $(window).scrollTop(); //retrieve the document scroll ToP position
    }
    recalculateSizes();

    jQuery(document).ready(function ($) {
        $('.nk-accordion').nkAccordion();

        $('select.wc-product-search.enhanced').each(function () {
            //Add sortable attribute to select2 product fields (upsell and cross-sell)
            $(this).attr('data-sortable', true);

            let $select = $(this);
            let $list = $(this).next('.select2-container').find('ul.select2-selection__rendered');

            $list.sortable({
                placeholder: 'ui-state-highlight select2-selection__choice',
                forcePlaceholderSize: true,
                items: 'li:not(.select2-search__field)',
                tolerance: 'pointer',
                stop: function () {
                    $($list.find('.select2-selection__choice').get().reverse()).each(function () {
                        var id = $(this).data('data').id;
                        var option = $select.find('option[value="' + id + '"]')[0];
                        $select.prepend(option);
                    });
                },
            });
        });
    });

    function move_list_cta() {
        if (!$('body.archive.woocommerce-page').length) return;
        const productsList = $('ul.products li.product');
        // console.log('productsList', productsList.length);
        const ctaSquare = $('.square-cta-el');
        const ctaRect = $('.rect-cta-el');
        const giftCard = $('.product-gift-cart-loop');
        if (productsList.length >= 5 && ctaSquare) {
            $(productsList[2]).after(ctaSquare);
            ctaSquare.css('display', 'block');
        }
        if (productsList.length >= 8 && ctaRect) {
            $(productsList[7]).after(ctaRect);
            ctaRect.css('display', 'block');
        }

        // console.log('productsList', productsList);
        if (productsList.length >= 5) {
            giftCard.appendTo('.products.columns-4');
            giftCard.find('.thumb-main-image').addClass('single-image');
            giftCard.css('display', 'block');
        }
    }
    move_list_cta();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Trade / Retail Addons
    //
    /*-------------------------------------------------------------------------*/
    function addonTradeRetail() {
        const retailOptionRemove = $(
            '.single-product.customer-trade .wc-pao-addon-description p:contains("retail")'
        ).closest('.wc-pao-addon-container');
        if (retailOptionRemove.length) retailOptionRemove.remove();

        const tradeOptionRemove = $(
            '.single-product.customer-retail .wc-pao-addon-description p:contains("trade")'
        ).closest('.wc-pao-addon-container');
        if (tradeOptionRemove.length) tradeOptionRemove.remove();
    }
    addonTradeRetail();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Single Product
    //
    /*-------------------------------------------------------------------------*/

    function applyZoom() {
        const zoomWrapper = $('.zoom-activate');
        if (!zoomWrapper.length) return;
        // console.log('zoom jest');
        recalculateSizes();
        if (windowWidth > 1100) {
            zoomWrapper.addClass('zoom');
            zoomWrapper.zoom({
                onZoomIn: function () {
                    $('.gallery-image .image-wrap').css('opacity', 0);
                },
                onZoomOut: function () {
                    $('.gallery-image .image-wrap').css('opacity', 1);
                },
            });
        } else {
            zoomWrapper.removeClass('zoom');
            zoomWrapper.trigger('zoom.destroy');
        }
    }
    applyZoom();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Header
    //
    /*-------------------------------------------------------------------------*/

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Add-on manipulation
    //
    /*-------------------------------------------------------------------------*/
    const addonsForm = $('form.cart'); // Holds events on addons

    // Update product price on addon change
    addonsForm.on('updated_addons', function () {
        const newAddonsPrice = $('.wc-pao-subtotal-line .amount').first();
        const outletWrapper = $('.entry-summary .outlet-price-now .woocommerce-Price-amount bdi');

        if (!newAddonsPrice.length || !$.trim(newAddonsPrice.text())) {
            return;
        }

        if (outletWrapper.length) {
            outletWrapper.html(newAddonsPrice.html());
        } else {
            $('.entry-summary .woocommerce-Price-amount bdi').first().html(newAddonsPrice.html());
        }
    });

    // Validate addons on Apple / Google Pay
    const stripeContainer = $('.wc-stripe-product-checkout-container');
    // console.log('stripeContainer', stripeContainer);
    // addonsForm.find('.wc-stripe-product-checkout-container button[type="button"]').on('click', function (e) {
    //     e.preventDefault;
    //     if (self.validation.validate(true)) {
    //         return true;
    //     }

    //     // Scroll viewport to the first invalid configured addon, if it not currently in viewport.
    //     var $messages = addonsForm.find('.wc-pao-validation-notice');

    //     if ($messages.length > 0) {
    //         var $first_invalid_addon = addonsForm.find($messages[0].closest('.wc-pao-addon-container'));

    //         if ($first_invalid_addon.length > 0 && !self.is_in_viewport($first_invalid_addon)) {
    //             $first_invalid_addon[0].scrollIntoView();
    //         }
    //     }

    //     return false;
    // });

    // Personalisation
    function handlePersonalisation() {
        const personalisationWrapper = $('.wc-pao-addon-description:contains("nk-product-personalisation")').closest(
            '.wc-pao-addon-container'
        );
        personalisationWrapper.css('opacity', '0').hide();
        if (!personalisationWrapper.length) return;

        if (windowWidth < 600) {
            $('.popup-personalisation .pop-image').prependTo('.popup-personalisation .pers-form');
        }

        const persInput = $('.popup-personalisation .form-letters');
        const persPreview = $('.popup-personalisation .letters');
        const persTargetAddon = personalisationWrapper.find('.wc-pao-addon-custom-text');
        let persValue;
        const allowed = /^[0-9a-zA-Z,.,-:]*$/;

        let personalisationSelect = $('.personalisation-select');
        const htmlPrice = personalisationWrapper.find('.wc-pao-addon-price').html();

        personalisationSelect.find('.pers-price').html(htmlPrice);

        persInput.on('input', function () {
            let persValueTemp = $(this).val();
            const regex = /[a-zA-Z0-9]/g; // only count letters and numbers
            let persValueChars = persValueTemp.match(regex).length;
            // console.log(persValueChars);
            if (persValueTemp.length > 8) return;
            const isAlowed = persValueTemp.match(allowed);
            if (!isAlowed || persValueChars > 5) {
                $(this).val(persValue);
            } else {
                persValue = isAlowed.input.toUpperCase();
                persPreview.text(persValue);
            }
            // console.log('pers added', isAlowed);
        });

        $('.submit-pers').on('click', function () {
            // console.log('persValue', persValue);
            persTargetAddon.val(persValue).trigger('change');
            personalisationSelect.addClass('pers-selected');
            personalisationSelect.find('.pers-val').text(persValue);
            if (persValue == '') personalisationSelect.removeClass('pers-selected');

            popupClose();
        });

        $(document).on('click', '.personalisation-select', function (e) {
            e.preventDefault();
            e.stopPropagation();
            popupOpen();
        });
        $(document).on('click', '.personalisation-select.pers-selected .pers-tick', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // console.log('tick');
            personalisationSelect.removeClass('pers-selected');
            persTargetAddon.val('').trigger('change');
            personalisationSelect.find('.pers-val').text('');
        });

        $('.popup-close').on('click', function () {
            popupClose();
        });
    }
    handlePersonalisation();

    // Colour
    function handleCoulour() {
        const colourWrapper = $('[data-addon-name="Colour"]').closest('.wc-pao-addon-container');
        // colourWrapper.css('background', 'red');
        if (!colourWrapper.length) return;
        let colourSelectedHtml = '<span class="nk-colour-selected">Colour</span>';
        colourWrapper.prepend(colourSelectedHtml);

        colourWrapper.find('label').hide();

        // select colour if just 1
        const numberofColours = colourWrapper.find('.wc-pao-addon-image-swatch');
        if (numberofColours.length == 1) {
            $('.wc-pao-addon-image-swatch').first().addClass('selected');
        }

        colourWrapper.on('click touchend', '.wc-pao-addon-image-swatch', function (e) {
            // console.log('swatch clicked');
            const colourValue = $(this).find('img').attr('alt').replace(/ [£$€]0.00/, '');
            let colourImage = $(this).find('img').attr('src');
            const colourValueForReplacement = colourValue.replace(/\s+/g, '');

            if (
                nk_ajax_vars.hasOwnProperty('personalisationOverrides') &&
                nk_ajax_vars.personalisationOverrides[colourValueForReplacement]
            )
                colourImage = nk_ajax_vars.personalisationOverrides[colourValueForReplacement];

            // console.log('colourValue', colourValue);
            // console.log('colourImage', colourImage);

            $('.nk-colour-selected').html(`Colour: <span>${colourValue}</span>`);
            $('.popup-personalisation .cta-box').html(`<img src="${colourImage}" />`);

            // scroll carousel
            const slideWithSwatch = $(`.gallery-image[data-color="${$.trim(colourValue)}"]`).first();
            if (slideWithSwatch.length) {
                const slideIndex = slideWithSwatch.parent().parent().index();
                var slickSlider = $('.gallery-images.slides')[0];

                $('.gallery-images.slides').slick('slickGoTo', slideIndex, true);
            }

            // console.log('swatch changed', colourValue);
            // console.log('swatch image', colourImage);
        });
    }
    handleCoulour();

    function popupOpen() {
        // console.log('popup opened');
        body.addClass('popup-opened popup-opened-personalisation');
        $window.disablescroll();
    }
    function popupClose() {
        // console.log('popup closed');
        body.removeClass('popup-opened');
        body.removeClass('popup-opened-personalisation');
        $window.disablescroll('undo');
    }

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Quantity button
    //
    /*-------------------------------------------------------------------------*/
    $(document).on('click', 'button.nk-plus, button.nk-minus', function () {
        const qty = $(this).parent('.quantity').find('.qty');
        let val = parseFloat(qty.val());
        let max = parseFloat(qty.attr('max'));
        let min = parseFloat(qty.attr('min'));
        let step = parseFloat(qty.attr('step'));
        if ($(this).is('.nk-plus')) {
            if (max && max <= val) {
                qty.val(max).change();
            } else {
                qty.val(val + step).change();
            }
        } else {
            if (min && min >= val) {
                qty.val(min).change();
            } else if (val > 1) {
                qty.val(val - step).change();
            }
        }
    });
    /*-------------------------------------------------------------------------*/
    //
    // INFO: Checkout & Cart (basket)
    //
    /*-------------------------------------------------------------------------*/
    function checkoutWrapTotals() {
        const checkoutTotals = $('.woocommerce-checkout-review-order-table');
        const checkoutTotalsWrapper = `<div class="cart-totals-wrapper"></div>`;
        if (!checkoutTotals.length) return;
        checkoutTotals.wrap(checkoutTotalsWrapper);
    }
    checkoutWrapTotals();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Gift Wrap
    //
    /*-------------------------------------------------------------------------*/
    function giftWrapInit() {
        let giftWrap = $('.gift-wrapping');
        if (!giftWrap.length) return;
        // console.log('Gift Wrapping Initiated');

        const giftWrapSlide = $('.gift-wrap-slide');
        const giftWrapTexarea = giftWrap.find('.customer-gift-wrap-text');
        let giftWrapAdd = giftWrap.find('.gift-wrap-title').hasClass('toogle-checked') ? true : false;
        let gift_add = giftWrapAdd ? 'yes' : 'no';
        let giftWrapMessage = !$.trim(giftWrapTexarea.val()) ? '' : $.trim(giftWrapTexarea.val());
        let giftData = {
            gift_add: gift_add,
            gift_message: giftWrapMessage,
            gift_notice: '',
        };

        let giftNotice = giftWrap.find('.gift-ajax-notice');

        giftWrap.on('click', '.gift-wrap-title', function () {
            $(this).toggleClass('toogle-checked');
            giftWrapSlide.slideToggle();
            giftWrapAdd = !giftWrapAdd;
            giftData.gift_add = giftWrapAdd ? 'yes' : 'no';
            giftData.gift_notice = 'This order will be sent as gift';

            // console.log('giftWrapAdd', giftData);
            giftWrapAjax();
        });

        giftWrap.on('click', '.wrap-save', function (e) {
            e.preventDefault();
            giftData.gift_message = $.trim(giftWrapTexarea.val());
            giftData.gift_notice = 'Message saved';
            giftWrapAjax();
        });
        giftWrap.on('click', '.wrap-cancel', function (e) {
            e.preventDefault();
            giftWrapTexarea.val('');
            giftData.gift_message = '';
            giftData.gift_notice = 'Message removed';
            giftWrapAjax();
        });

        function giftWrapAjax() {
            $.ajax({
                url: nk_ajax_vars.ajaxurl,
                type: 'post',
                dataType: 'json',
                data: {
                    action: 'nk_ajax_gift_status',
                    security: nk_ajax_vars.nkNonce,
                    giftData: giftData,
                },
                beforeSend: function () {
                    giftWrap.addClass('processing');
                },
                success: function (data) {
                    giftNoticeShow(giftData.gift_notice);
                    giftWrap.removeClass('processing');
                },
                error: function (responce) {
                    console.log('failed: ' + responce);
                    giftNoticeShow('Something went wrong');
                    giftWrap.removeClass('processing');
                },
            });
        }

        function giftNoticeShow(text) {
            giftNotice.show().text(text);
            setTimeout(function () {
                giftNotice.fadeOut(function () {
                    giftNotice.text('');
                });
            }, 3000);
        }
    }
    giftWrapInit();

    /*-------------------------------------------------------------------------*/
    //
    //!*    INFO: Gift Wrap
    //
    /*-------------------------------------------------------------------------*/
    function tradeMessageInit() {
        let tradeMessage = $('.trade-message-wrap');
        if (!tradeMessage.length) return;

        const tradeMessageWrapTexarea = tradeMessage.find('.trade-message-wrap-text');
        let tradeMessageText = !$.trim(tradeMessageWrapTexarea.val()) ? '' : $.trim(tradeMessageWrapTexarea.val());
        let tradeMessageData = {};
        let messageNotice = tradeMessage.find('.message-ajax-notice');

        tradeMessage.on('click', '.message-save', function (e) {
            e.preventDefault();
            tradeMessageData = {
                message_add: 'yes',
                trade_message: $.trim(tradeMessageWrapTexarea.val()),
                trade_notice: 'Message saved',
            };
            tradeMessageAjax();
        });
        tradeMessage.on('click', '.message-cancel', function (e) {
            e.preventDefault();
            tradeMessageData = {
                message_add: 'no',
                trade_message: '',
                trade_notice: 'Message removed',
            };
            tradeMessageWrapTexarea.val('');
            tradeMessageAjax();
        });
        $('.customer-trade').on('click', '.trade-checkout', function (e) {
            const buttonLink = $(this).attr('href');
            e.preventDefault();
            tradeMessageData = {
                message_add: 'yes',
                trade_message: $.trim(tradeMessageWrapTexarea.val()),
                trade_notice: 'Message saved',
                trade_checkout: buttonLink,
            };
            tradeMessageAjax();
        });

        function tradeMessageAjax() {
            $.ajax({
                url: nk_ajax_vars.ajaxurl,
                type: 'post',
                dataType: 'json',
                data: {
                    action: 'nk_ajax_trade_message',
                    security: nk_ajax_vars.nkNonce,
                    tradeMessageData: tradeMessageData,
                },
                beforeSend: function () {
                    tradeMessage.addClass('processing');
                },
                success: function (data) {
                    tradeMessageNoticeShow(tradeMessageData.trade_notice);
                    tradeMessage.removeClass('processing');
                    if (tradeMessageData.trade_checkout) {
                        // console.log(tradeMessageData);
                        window.location.href = tradeMessageData.trade_checkout;
                    }
                },
                error: function (responce) {
                    console.log('failed: ' + responce);
                    tradeMessageNoticeShow('Something went wrong');
                    tradeMessage.removeClass('processing');
                },
            });
        }

        function tradeMessageNoticeShow(text) {
            messageNotice.show().text(text);
            setTimeout(function () {
                messageNotice.fadeOut(function () {
                    messageNotice.text('');
                });
            }, 3000);
        }
    }
    tradeMessageInit();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Wish list
    //
    /*-------------------------------------------------------------------------*/
    function handleWishList() {
        const wishListIcon = $('.icon-wish-list');
        if (!wishListIcon.length) return;
        wishListIcon.on('click', function (e) {
            e.preventDefault();

            let fav = $(this);
            if (fav.hasClass('executing')) return;

            fav.addClass('executing');
            let add_remove = $(this).hasClass('product-added') ? 'remove' : 'add';
            let favID = $(this).data('fav-id');
            let favAjax = $.ajax({
                type: 'POST',
                dataType: 'json',
                url: nk_ajax_vars.ajaxurl,
                data: {
                    action: 'nk_fav_select',
                    add_remove: add_remove,
                    fav_ID: favID,
                    security: nk_ajax_vars.nkNonce,
                },
                success: function (data) {
                    const numberOfFav = data.data.numberOfFavourites;
                    fav.removeClass('executing');
                    fav.toggleClass('product-added');
                    const menuBadge = $('.nk-fav-items');
                    menuBadge.text(numberOfFav);
                    if (numberOfFav > 0) {
                        menuBadge.removeClass('fav-hidden');
                    } else {
                        menuBadge.addClass('fav-hidden');
                    }
                    if ($('body.page-template-page-wishlist').length) {
                        fav.closest('li.product').fadeOut();
                        if (numberOfFav == 0) {
                            $('.row-woocommerce ul.products').html(
                                `<p>You haven’t added any items to your wishlist.</p>`
                            );
                        }
                    }
                    // console.log('data', data);
                },
                error: function (error) {
                    fav.removeClass('executing');
                },
            });
        });
    }
    handleWishList();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: toggels
    //
    /*-------------------------------------------------------------------------*/
    function handleShippingToggle() {
        // if(!$('#ship-to-different-address').length) return;
        const toggleHtml = `<span class="toggler"></span>`;
        $('#ship-to-different-address label').append(toggleHtml);

        $(document).on('load change', '#ship-to-different-address input', function (e) {
            if ($(this).is(':checked')) {
                $(this).closest('.woocommerce-shipping-fields').addClass('toogle-checked');
            } else {
                $(this).closest('.woocommerce-shipping-fields').removeClass('toogle-checked');
            }
        });
    }
    handleShippingToggle();

    function handleCreateAccountToggle() {
        if (!$('.woocommerce-checkout .create-account').length) return;
        const whyAccount = `<span class="why-account">Become a Croots Community member to receive exclusive offers including 5% off every order, enjoy faster checkout and manage your orders all in one place.<span>`;
        const emailAccountDetails = `<div class="account-details-email" class="display:none">We will send account details in a separate email<div>`;
        const toggleHtml = `<span class="toggler"></span>`;
        // $('.woocommerce-account-fields .create-account').prepend(whyAccount);
        $('.woocommerce-account-fields .create-account').append(emailAccountDetails);
        $('.woocommerce-account-fields .create-account label').append(toggleHtml);

        $(document).on('load change', '#createaccount', function (e) {
            if ($(this).is(':checked')) {
                $(this).closest('.checkbox').addClass('toogle-checked');
                $('.account-details-email').slideDown();
                handleRegistrationCoupon('add');
            } else {
                $(this).closest('.checkbox').removeClass('toogle-checked');
                $('.account-details-email').slideUp();
                handleRegistrationCoupon('remove');
            }
        });

        $('.mailchimp-signup input[type=checkbox]').closest('label').addClass('checkbox-control');
        $('.acf-field-6543f875a283d').hide();
        $('.acf-field-6543f78ea283c input[type=checkbox]').prop('checked', false);
        $('.acf-field-6543f875a283d input[type=checkbox]').prop('checked', true);
        $('.acf-field-6543f78ea283c input[type=checkbox]').on('change', function () {
            if ($(this).is(':checked')) {
                $('.acf-field-6543f875a283d').slideDown();
            } else {
                $('.acf-field-6543f875a283d').slideUp();
            }
        });
    }
    handleCreateAccountToggle();

    function handleRegistrationCoupon(couponAction) {
        $.ajax({
            url: nk_ajax_vars.ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                action: 'nk_ajax_registration_coupon',
                security: nk_ajax_vars.nkNonce,
                couponAction: couponAction,
            },
            beforeSend: function () {},
            success: function (data) {
                $(document.body).trigger('update_checkout');
            },
            error: function (responce) {
                console.log('failed: ' + responce);
                $(document.body).trigger('update_checkout');
            },
        });
    }
    $(document.body).on('applied_coupon_in_checkout updated_checkout', function () {
        // console.log('checkout updated');
        $('.coupon-87jnv8m6 > th').html('New Community Member Discount');
        $('.coupon-87jnv8m6').show();
    });

    function toggleRegisterForm() {
        if (!$('.nk-login-form').length) return;
        $('.register-open').on('click', function (e) {
            e.preventDefault();
            $('.nk-login-form .register-info').slideUp();
            $('.nk-login-form .narrow > h1').slideUp();
            $('#customer_login .u-column1').slideUp();
            $('#customer_login .u-column2').slideDown();
        });
        $('.register-close').on('click', function (e) {
            e.preventDefault();
            $('.nk-login-form .register-info').slideDown();
            $('.nk-login-form .narrow > h1').slideDown();
            $('#customer_login .u-column1').slideDown();
            $('#customer_login .u-column2').slideUp();
        });

        // add class to checkboxes
        $('input[type=checkbox').closest('label').addClass('checkbox-control');
    }
    toggleRegisterForm();

    /*-------------------------------------------------------------------------*/
    //
    /* !	Marketing Popup
    //
    /*-------------------------------------------------------------------------*/

    body.on('click', '.open-marketing-popup', function () {
        popupOpenMarketing();
    });
    function popupOpenMarketing() {
        // console.log('popup-opened-marketing');
        body.addClass('popup-opened-marketing');
        Cookies.set('sign-up-seen', '1', { expires: 31 });
    }

    function popupCloseMarketing() {
        // console.log('popup closed');
        body.removeClass('popup-opened-marketing');
        $window.disablescroll('undo');
    }

    $('.popup-marketing .popup-close').on('click', function () {
        popupCloseMarketing();
    });

    function autoMarketingPopup() {
        if (nk_ajax_vars.userSigned) return;
        if (Cookies.get('sign-up-seen')) return;
        setTimeout(function () {
            popupOpenMarketing();
        }, 10000);
    }
    autoMarketingPopup();

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Site Navigation
    //
    /*-------------------------------------------------------------------------*/
    function siteNavigationInit() {
        $('.site-navigation .menu-item-has-children .media-wrapper').each(function (index) {
            $(this).appendTo($(this).closest('.menu-item-has-children').find('.sub-menu-wrap'));
        });
        $('.site-navigation .site-nav-media').each(function (index) {
            $(this).appendTo($(this).closest('.wrap').find('.menu-about-container'));
        });

        // main navigation
        $('.main-navigation').on('click', 'a', function (e) {
            e.preventDefault();
            const menuLiItem = $(this).closest('.main-top-level');
            const menuID = menuLiItem.data('menu');
            closeNavigation();
            if (menuLiItem.hasClass('menu-item-active')) {
                menuLiItem.removeClass('menu-item-active');
            } else {
                $('.menu-item-active').removeClass('menu-item-active');
                menuLiItem.addClass('menu-item-active');
                $('#' + menuID).addClass('navigation-active');
                $window.disablescroll();
            }
        });

        // Sub navigation
        $('.site-navigation').on('click', '.menu-item-has-children > a', function (e) {
            e.preventDefault();
            const menuLiItem = $(this).closest('.menu-item-has-children');
            if (menuLiItem.hasClass('sub-menu-active')) {
                menuLiItem.removeClass('sub-menu-active');
                $('.site-navigation').removeClass('sub-menu-opened');
            } else {
                $('.sub-menu-active').removeClass('sub-menu-active');
                menuLiItem.addClass('sub-menu-active');
                $('.site-navigation').addClass('sub-menu-opened');
            }
        });

        $('.site-navigation').on('click', 'a[href="#"]', function (e) {
            e.preventDefault();
        });
    }
    siteNavigationInit();
    function closeNavigation() {
        $('.sub-menu-opened').removeClass('sub-menu-opened');
        $('.sub-menu-active').removeClass('sub-menu-active');
        $('.navigation-active').removeClass('navigation-active');
        $window.disablescroll('undo');
    }

    function siteSearch() {
        $('.user-search').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('search-active')) {
                productSearchClose();
            } else {
                productSearchOpen();
            }
        });
    }
    siteSearch();

    function productSearchOpen() {
        $('.user-search').addClass('search-active');
        $('.nk-search-products').addClass('search-opened');
        $window.disablescroll({
            scrollEventKeys: [33, 34, 35, 36, 37, 38, 39, 40],
        });
    }
    function productSearchClose() {
        $('.user-search').removeClass('search-active');
        $('.nk-search-products').removeClass('search-opened');
        $window.disablescroll('undo');
    }

    /*-------------------------------------------------------------------------*/
    //
    // INFO: Mobile navigation
    //
    /*-------------------------------------------------------------------------*/
    $('.hamburger-box').on('click', function () {
        body.toggleClass('mobile-menu-active');
    });

    $('.menu-item-has-children > a ').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.menu-item-has-children').addClass('mobile-submenu-active');
    });

    $('.submenu-back').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.menu-item-has-children').removeClass('mobile-submenu-active');
    });
    /*-------------------------------------------------------------------------*/
    //
    // INFO: Filters & Order by
    //
    /*-------------------------------------------------------------------------*/
    function productFilterInit() {
        const productFilterWrapper = $('.product-filters');
        if (!productFilterWrapper.length) return;

        const params = new URLSearchParams(window.location.search);
        let currentUrl = window.location.href;
        const isPagedSubstring = '/page/';
        const isPaged = currentUrl.includes(isPagedSubstring) ? true : false;
        const isParamSubstring = '/?';
        const isParam = currentUrl.includes(isParamSubstring) ? true : false;
        if (isPaged) {
            const pageIndex = currentUrl.toLowerCase().indexOf(isPagedSubstring.toLowerCase());
            currentUrl = currentUrl.substring(0, pageIndex);
        } else {
            if (isParam) {
                const pageIndex = currentUrl.toLowerCase().indexOf(isParamSubstring.toLowerCase());
                currentUrl = currentUrl.substring(0, pageIndex);
            }
        }

        productFilterWrapper.on('click', '.filters-button', function (e) {
            $(this).toggleClass('filters-opened');
            productFilterWrapper.find('.filters-product-top').slideToggle();
        });

        productFilterWrapper.on('click', '.top-cat', function () {
            $(this).toggleClass('active-top');
            $(this).find('.filter-sub').slideToggle();
        });
        productFilterWrapper.on('click', '.filter-item', function (e) {
            e.stopPropagation();
            if ($(this).hasClass('active-child')) {
                $(this).removeClass('active-child');
            } else {
                $(this).closest('.filter-sub').find('.active-child').removeClass('active-child');
                $(this).addClass('active-child');
            }
        });
        $('.filter-submit').on('click', function (e) {
            e.preventDefault();

            const filters = productFilterWrapper.find('.active-child');

            let filtersValues = [];
            filters.each(function () {
                filtersValues.push($(this).data('filter'));
            });
            const filtersString = filtersValues.join(',');

            if (filtersValues.length) {
                params.set('show', filtersString);
            } else {
                params.delete('show');
            }

            const newParams = params.size > 0 ? `?${params.toString()}` : '';
            location.href = `${currentUrl}/${newParams}`;
        });
        $('.filter-reset').on('click', function (e) {
            e.preventDefault();
            let params = new URLSearchParams(window.location.search);
            params.delete('show');
            const newParams = params.size > 0 ? `?${params.toString()}` : '';
            location.href = `${currentUrl}/${newParams}`;
        });
    }
    productFilterInit();
    function closeProductFilter() {
        $('filters-opened').removeClass('filters-opened');
        $('.filters-product-top').slideUp();
    }

    function orderByInit() {
        const orderByWrapper = $('.product-order');
        if (!orderByWrapper.length) return;

        let currentUrl = window.location.href;
        const isPagedSubstring = '/page/';
        const isPaged = currentUrl.includes(isPagedSubstring) ? true : false;
        const isParamSubstring = '/?';
        const isParam = currentUrl.includes(isParamSubstring) ? true : false;
        if (isPaged) {
            const pageIndex = currentUrl.toLowerCase().indexOf(isPagedSubstring.toLowerCase());
            currentUrl = currentUrl.substring(0, pageIndex);
        } else {
            if (isParam) {
                const pageIndex = currentUrl.toLowerCase().indexOf(isParamSubstring.toLowerCase());
                currentUrl = currentUrl.substring(0, pageIndex);
            }
        }

        orderByWrapper.on('click', '.order-button', function () {
            $(this).toggleClass('order-opened');
            orderByWrapper.find('.order-sub').slideToggle();
        });

        orderByWrapper.on('click', '.order-item', function (e) {
            e.stopPropagation();
            if ($(this).hasClass('active-child')) {
                $(this).removeClass('active-child');
            } else {
                $(this).closest('.order-sub').find('.active-child').removeClass('active-child');
                $(this).addClass('active-child');
            }
        });
        $('.order-submit').on('click', function (e) {
            e.preventDefault();
            let params = new URLSearchParams(window.location.search);
            const orderBy = orderByWrapper.find('.active-child');
            let orderByValues = [];
            orderBy.each(function () {
                orderByValues.push($(this).data('order'));
            });
            const orderByString = orderByValues.join(',');

            if (orderByValues.length) {
                params.set('orderby', orderByString);
            } else {
                params.delete('orderby');
            }
            const newParams = params.size > 0 ? `?${params.toString()}` : '';
            location.href = `${currentUrl}/${newParams}`;
        });
        $('.order-reset').on('click', function (e) {
            e.preventDefault();
            let params = new URLSearchParams(window.location.search);
            params.delete('orderby');
            const newParams = params.size > 0 ? `?${params.toString()}` : '';
            location.href = `${currentUrl}/${newParams}`;
        });
    }
    orderByInit();
    function closeOrderBy() {
        $('order-opened').removeClass('order-opened');
        $('.order-sub').slideUp();
    }

    // execute on resize but only once

    function headerSize() {
        const windowTopPos = $(window).scrollTop();
        if (windowTopPos >= 100) {
            body.addClass('header-small');
        } else {
            body.removeClass('header-small');
        }
    }
    headerSize();

    var doResize;
    $(window).on('resize', function () {
        clearTimeout(doResize);
        doResize = setTimeout(function () {}, 300);
    });

    var doScroll;
    $(window).on('scroll', function () {
        headerSize();
        clearTimeout(doScroll);
        doScroll = setTimeout(function () {}, 300);
    });

    $(window).on('orientationchange', function (event) {});
    $(document).on('click', function (event) {
        if (
            !$(event.target).closest('.site-navigation .wrap').length &&
            !$(event.target).closest('.main-navigation').length
        ) {
            closeNavigation();
            $('.main-navigation .menu-item-active').removeClass('menu-item-active');
        }
        if (
            !$(event.target).closest('.dgwt-wcas-search-wrapp').length &&
            !$(event.target).closest('.user-search').length
        ) {
            productSearchClose();
        }
        if (!$(event.target).closest('.popup-content').length) {
            popupClose();
        }
        if (!$(event.target).closest('.product-filters').length) {
            closeProductFilter();
        }
        if (!$(event.target).closest('.product-order').length) {
            closeOrderBy();
        }
    });
    $(window).on('beforeunload', function () {
        body.trigger('close-modals');
    });

    body.on('close-modals', function (event) {});
    body.keydown(function (event) {
        if (event.which == 27) {
            closeNavigation();
            $('.main-navigation .menu-item-active').removeClass('menu-item-active');
            productSearchClose();
            popupClose();
            closeProductFilter();
            closeOrderBy();
            popupCloseMarketing();
        }
    });

    // function splitLetters() {
    //     let splitLettersDiv = $('.animate-letters');
    //     if (!splitLettersDiv.length) return;

    //     const results = Splitting({ target: splitLettersDiv, by: 'chars' });
    // }
    // splitLetters();
});

jQuery(document).on('load', function () {
    // deferImages();
    // console.log('Document loaded');
});

// Prevents passive listeners in jQuery, used for Google PageSpeed
jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener('touchstart', handle, {
            passive: !ns.includes('noPreventDefault'),
        });
    },
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener('touchmove', handle, {
            passive: !ns.includes('noPreventDefault'),
        });
    },
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener('wheel', handle, { passive: true });
    },
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener('mousewheel', handle, { passive: true });
    },
};
jQuery(document).ready(function ($) {
    document.body.classList.add('document-loaded');
});

// window.onload = () => {
//     if (windowWidth > 760) return;
//     let swatches = document.querySelectorAll('a.wc-pao-addon-image-swatch');
//     if (!swatches.length) return;
//     swatches.forEach((el) => {
//         el.addEventListener(
//             'mouseover',
//             (e) => {
//                 e.stopImmediatePropagation();
//                 e.stopPropagation();
//             },
//             true
//         );
//     });
// };
